const Api = {
    '/api/talent/add-dy-talent': 1, // 添加达人
    '/api/tags/set-anchor-tags': 1, // 达人打标签
    '/api/talent/claim': 1, // 找达人 认领达人
    '/api/team-sea/sea-claim': 1, // 团队公海 认领达人
    '/api/team-sea/sea-allot': 1, // 重新分配
    '/saas-api/anchor/partner/team-anchor/modify-cooperate': 1, // 修改合作状态 团队公海
    '/saas-api/anchor/partner/partner-anchor/modify-cooperate': 1, // 修改合作状态 我的达人
    '/saas-api/anchor/partner/team-anchor/batch-modify': 1, // 批量修改合作状态 团队公海
    '/saas-api/anchor/partner/partner-anchor/batch-modify': 1, // 批量修改合作状态 我的达人
    '/api/team-conf/circulation-config': 1, // 达人规则-设置达人跟进
    '/api/partner-anchor/add-fix-task': 1,  // 快手-设置达人规则
};

export default {
    Api
};